import { allTrackers } from "app/services/track/track";
import { PreferencesService } from "app/services/preferences/preferencesService";
import type { CategoryId } from "app/common/services/categoryService.types";
import type { ITableData } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/getTableData";
import type { IFilters } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/types";

export const PREFERENCES_SERVICE_FAVORITES_KEY = "market_research_pre_defined_benchmark_table_favorites";

const updatePreferencesApi = (favorites) => {
    PreferencesService.add({
        [PREFERENCES_SERVICE_FAVORITES_KEY]: favorites,
    });
};

const onFavoritesClickTracking = (row) => {
    const { isFavorite } = row;
    const { text: category, parentItem } = row.category;
    const isChildCategory = Boolean(parentItem);
    const eventName = isChildCategory ? `Star/${parentItem.text}/${category}` : `Star/${category}`;
    allTrackers.trackEvent("Click Filter", isFavorite ? "remove" : "add", eventName);
};

export const onFavoriteClickHof =
    (
        tableData: ITableData,
        favorites: Array<CategoryId>,
        setFavorites: (categories: Array<CategoryId>) => void,
        filters: IFilters,
        setFilters: (filters: IFilters) => void,
    ) =>
    (rowIndex: number) => {
        const row = tableData.Records[rowIndex];
        const { id } = row.category;
        onFavoritesClickTracking(row);
        const newFavorites = favorites.includes(id)
            ? favorites.filter((categoryID) => categoryID !== id)
            : [...favorites, id];
        setFavorites(newFavorites);
        updatePreferencesApi(newFavorites);
        if (newFavorites.length === 0) {
            setFilters({ ...filters, isFavorites: false });
        }
    };
